import { Component, OnInit } from "@angular/core";
import { ActivatedRoute,Router } from "@angular/router";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { HttpClient ,HttpHeaders,HttpErrorResponse  } from '@angular/common/http';
import { formatDate } from "@angular/common";
import { Location } from '@angular/common';
import { LoaderService } from 'src/app/loader.service';

type UserFields = "email" | "password";
type FormErrors = { [u in UserFields]: string };
import { environment } from 'src/environments/environment';
import { UploadService } from './upload.service';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {

	val:any;
	sub:any;
	customers:any;
	isShown: boolean = false ;	
	submitted: boolean = false;
	submittedSeller: boolean = false;
	cmpisShown: boolean = false ;	
	cmpsubmitted: boolean = false;	
	actMsg: boolean=false;
	poMessage: boolean;	
	poMessage1: boolean;	
	msg:any;
	msgSeller:any;
	cmpmsg:any;
	dst_date_from:any;
	dst_date_to:any;
	headers = new HttpHeaders({ 'Content-Type': 'application/json','API_KEY':'20e20m06i16e14r31p','Version':'1.0' });    	 
	options = { headers: this.headers };	
	username:any;
	password:any;
	token:any;
	opt:any;
	
	iv:any;
	siv:any;
	registerMsg:any;
	seller_id:any;
	company_po_id:any;
	
	logo_upload:any;
	logo:any;
	cdn_url:any;
	
	public newUser = false;
	// public user: firebase.User;
	public loginForm: FormGroup;
	public loginFormSeller: FormGroup;

	public errorMessage: any;

	constructor(private fb: FormBuilder, public router: Router,private route: ActivatedRoute,private http: HttpClient,private location: Location,private uploadService: UploadService,private loadingService: LoaderService) {
	this.loginForm = this.fb.group({
	  email: ['', Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")],
	  pw: ["", Validators.required],
	});
	
	this.loginFormSeller = this.fb.group({
	  email: ["", Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")],
	  pw: ["", Validators.required],
	});
	}
	
	

  ngOnInit() 
  {  		
		 this.cdn_url=environment.cdn_url_home;		
		
		this.sub = this.route
      .queryParams
      .subscribe(params => {
		  //alert(JSON.stringify(params['activation']));
        // Defaults to 0 if no query param provided.
        this.val = params['activation'];
		this.iv = params['a'];
		this.siv = params['b'];
		//alert(params['activation']);
		
			this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.options).subscribe((response) => 
			{
				this.token=response;
				//alert(this.token.access_token);
				let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
				let o = { headers: h };
				if(this.val!==undefined && this.iv!==undefined)
				{				
					this.http.post(environment.api_url+'/v1/companyPO/activation',{ activation : this.val,iv : this.iv },o).subscribe((response) => 
					{		
								
								this.actMsg=true;
								this.registerMsg="Your Email is Verified. Now you can login your seller admin account";											
					});
				}
				else if(this.val!==undefined && this.siv!==undefined)
				{
					this.http.post(environment.api_url+'/v1/companySeller/activation',{ activation : this.val,iv : this.siv },o).subscribe((response) => 
					{									
								this.actMsg=true;
								this.registerMsg="Your Email is Verified. Now you can login your seller location account";											
					});
				}
			});	
					
      });						
	  	 
  
  
  }

  login() {
  
  //localStorage.clear();	
	  
    this.submitted = true;
        // stop here if form is invalid
	if (this.loginForm.invalid) 
	{		
		return;
	}	
	
	
	
	this.http.post(environment.api_url+'/auth/login', {"username": "john", "password": "changeme"},this.options).subscribe((response) => 
	{
		this.token=response;
		//alert(this.token.access_token);
		let h = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':'Bearer '+this.token.access_token,'Access-Control-Allow-Origin': "*" });    	 
		let o = { headers: h };
						
		this.http.post(environment.api_url+'/signin',this.loginForm.value,o).subscribe((response) => 
		{
				
				
				localStorage.setItem('userDetails', JSON.stringify(response[0]));
				
				localStorage.setItem('userName', response[0].business_name);
				
				localStorage.setItem('userType', 'Admin');
				
				localStorage.setItem('user_po_id', response[0].user_po_id);	
				
				localStorage.setItem('company_po_id', response[0].company_po_id);
				
				localStorage.setItem('business_name', response[0].business_name);
				
				localStorage.setItem('business_subdomain', response[0].business_subdomain);
				
				localStorage.setItem('business_type', response[0].business_type);
				
				this.logo=this.cdn_url+"/"+response[0].company_po_id+"/"+response[0].logo_upload;
				
				localStorage.setItem('logo', this.logo);
				
			
				
				
				
					if(response[0].pw_changed==false)
					{
						this.router.navigate(['/auth/ChangePassword']);
					}
					else if(response[0].primary_login==false)
					{
						this.router.navigate(['/master/ViewSeller']);
					}
					else if(response[0].primary_login==true)
					{
						//alert(response[0].signup_process_over);
						if(response[0].signup_process_over==true)
						{
							this.router.navigate(['/master/ViewSeller'])	
						}
						else
						{
							if(response[0].signup_page1_over==true)
							{
								//alert("1");
								if(response[0].signup_page2_over==true)
								{
									//alert("2");
									if(response[0].signup_page6_over==true)
									{
																																
										this.router.navigate(['/master/ViewSeller']);	
										
									}
									else 
									{
										this.router.navigate(['/auth/SignupProcess'],{ queryParams: { val: 2 } })	
									}												
								}
								else 
								{
									this.router.navigate(['/auth/SignupProcess'],{ queryParams: { val: 2 } })	
									
								}							
								//this.router.navigate(['/auth/SignupProcess'])	
								
							}
							else 
							{
								this.router.navigate(['/auth/SignupProcess'])	
							}
						
						}
					}
					
				
			
		},(err: HttpErrorResponse) => {
		  if (err instanceof Error) {
			// client-side error
			//alert(JSON.stringify(err));
			//this.message = `An error occured ${err.error.message}`;
		  } 
		  else 
		  {					  					
			  this.isShown=true;
			this.msg=err.error.message;
			return;
			 
			//this.message = `Backend returned error code ${err.status}, body was: ${err.message}`;
		  }
		});
	});			
	  
  }
  
  
  
  
  

  loginFacebook(){

  }
  loginTwitter(){

  }
  loginGoogle(){

  }
  
 

}
